import "./App.css";
import Router from "./Router";
import { useIdleTimer } from "react-idle-timer";
import { useAppDispatch, useAppSelector } from "./Redux/app/hooks";
import { toTimestamp } from "./Helpers/generals";
import { Logout, restoreUser } from "./Redux/Reducers/userReducer";
import { memoizedRefreshToken } from "./Apis/refreshToken";
import { restoreMerchantDetails } from "./Redux/Reducers/overviewReducer";
import { useEffect } from "react";
import ProductionSwitchModal from "./components/Modals/ProductionSwitchModal";

const App = () => {
  const dispatch = useAppDispatch();
  const { currentUser } = useAppSelector((state) => state.user);

  const handleOnIdle = () => {
    if (currentUser) {
      if (currentUser?.expiresAtTimestamp > toTimestamp(new Date())) {
      } else {
        dispatch(Logout());
      }
    }
  };

  const handleOnActive = async () => {
    if (currentUser) {
      if (currentUser?.expiresAtTimestamp < toTimestamp(new Date())) {
        if (isIdle() === false) {
          await memoizedRefreshToken();
        } else {
          dispatch(Logout());
        }
      }
    }
  };

  const { isIdle } = useIdleTimer({
    timeout: 1000 * 60 * 5,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    debounce: 500,
  });

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("currentUser") || "{}");
    if (user) {
      dispatch(restoreUser(user));
      dispatch(restoreMerchantDetails());
    }
  }, []);

  return (
    <div className="App">
      <ProductionSwitchModal />
      <Router />
    </div>
  );
};

export default App;
